import { render } from "./AddPaymentModal.vue?vue&type=template&id=3a8a4759"
import script from "./AddPaymentModal.vue?vue&type=script&lang=js"
export * from "./AddPaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__